import type { ReactNode } from "react";
import { Navigate } from "react-router";
import { FullScreenLoader } from "@/components/spinner";
import { useSession } from "@/services/auth0/session";

/**
 * Gate that requires a logged-in OPERATOR. While Auth0/session resolve, show a
 * loader; unauthenticated → /login; authenticated-but-not-operator → /no-access.
 */
export function ProtectedRoute({ children }: { children: ReactNode }) {
  const { isLoading, isLoggedIn, isOperator } = useSession();

  if (isLoading) return <FullScreenLoader label="Loading…" />;
  if (!isLoggedIn) return <Navigate to="/login" replace />;
  if (!isOperator) return <Navigate to="/no-access" replace />;
  return <>{children}</>;
}
